import { useState } from 'react'

import { PlanRenewalType } from '@tribeplatform/gql-client/types'
import { GridList } from '@tribeplatform/react-ui-kit/Layout'
import { Toggle } from '@tribeplatform/react-ui-kit/Toggle'

import { UpgradePlanCard } from './UpgradePlanCard'
import { plans } from './utils'

export const PlansComponent = () => {
  const [renewalType, setRenewalType] = useState<PlanRenewalType>(
    PlanRenewalType.MONTH,
  )

  return (
    <div className="space-y-5">
      <div className="flex space-x-1">
        <div>Monthly</div>
        <Toggle
          checked={renewalType === PlanRenewalType.YEAR}
          onChange={value => {
            setRenewalType(value ? PlanRenewalType.YEAR : PlanRenewalType.MONTH)
          }}
        />
        <div>
          Yearly <span className="font-bold ml-2">2 MONTHS FREE</span>
        </div>
      </div>
      <GridList columns={4}>
        {plans.map(plan => (
          <GridList.Item key={plan}>
            <UpgradePlanCard planName={plan} renewalType={renewalType} />
          </GridList.Item>
        ))}
      </GridList>
    </div>
  )
}
